import React from "react";

import BelieveSection from "../components/BelieveSection";
import CustomCarousel from "../components/CustomCarousel";
import ClubSection from "../components/ClubSection";
import Footer from "../components/Footer";
import HerdSection from "../components/HerdSection";
import Incredible from "../components/Incredible";
import Navbar from "../components/Navbar";
import Standard from "../components/Standard";
import Roadmap from "../components/Roadmap";
import Story from "../components/Story";

const Home = (props) => {
  return (
    <>
      <Navbar />
      <ClubSection />
      <CustomCarousel />
      <Story />
      <Standard />
      <Roadmap />
      <Incredible />
   
      <HerdSection />
      <Footer />
    </>
  );
};
export default Home;
